var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('view',{staticClass:"photos-viewer"},[_c('vue-easy-lightbox',{attrs:{"visible":_vm.visible,"imgs":_vm.imgs,"index":_vm.index},on:{"hide":_vm.handleHide}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }